import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ReportCont } from './Report.styles';
import ReportDetails from '../../components/ReportDetails/ReportDetails';
import EffectReportDetails from '../../components/ReportLayout/EffectReportDetails/EffectReportDetails';
import GoodTeamReportDetails from '../../components/ReportLayout/GoodTeamReportDetails/GoodTeamReportDetails';
import ReportLayout from '../../components/ReportLayout/ReportLayout';
import { surveyTypes } from '../../constans/forms';
import { useReports } from '../../hooks/useReports';
import { IGetReportDetailsResp } from '../../services/reports';

const Report = () => {
  const { reportId } = useParams();
  const { getReportDetails } = useReports();
  const [searchParams] = useSearchParams();

  const [details, setDetails] = useState<IGetReportDetailsResp | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const details = await getReportDetails(reportId || '0');

        if (details) {
          setDetails(details);
        }
      } catch (error) {
        // TODO: handle errors
      }
    })();
  }, []);

  if (!details) {
    return null;
  }

  const surveyType = searchParams.get('surveyType') || details.survey?.type;

  const renderDetails = () => {
    switch (surveyType) {
      case surveyTypes.EFFECT:
        return <EffectReportDetails />;
      case surveyTypes.GOOD_TEAM:
        return <GoodTeamReportDetails />;
      case surveyTypes.ADAPT:
      case surveyTypes.PULSE:
      default:
        return <ReportDetails />;
    }
  };

  return (
    <ReportCont id="ReportCont">
      <ReportLayout details={details}>{renderDetails()}</ReportLayout>
    </ReportCont>
  );
};

export default Report;
